/**
 * Redimensionne une image (File) côté navigateur AVANT l'envoi au serveur.
 * Évite d'uploader des fichiers de plusieurs Mo (lent sur mobile) : l'image est
 * réduite via <canvas> puis encodée en JPEG. Le serveur applique ensuite sa propre
 * limite, mais l'upload devient quasi instantané.
 *
 * @param {File} file        Fichier image source
 * @param {number} maxPx     Dimension max (largeur ou hauteur)
 * @param {number} quality   Qualité JPEG (0..1)
 * @returns {Promise<string>} data URL JPEG redimensionnée
 */
export function resizeImageToDataURL(file, maxPx = 512, quality = 0.85) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const img = new Image();
            img.onload = () => {
                try {
                    let { width, height } = img;
                    if (Math.max(width, height) > maxPx) {
                        if (width >= height) {
                            height = Math.round((height * maxPx) / width);
                            width = maxPx;
                        } else {
                            width = Math.round((width * maxPx) / height);
                            height = maxPx;
                        }
                    }
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    // Fond blanc : la transparence (PNG) deviendrait noire en JPEG sinon
                    ctx.fillStyle = '#ffffff';
                    ctx.fillRect(0, 0, width, height);
                    ctx.drawImage(img, 0, 0, width, height);
                    resolve(canvas.toDataURL('image/jpeg', quality));
                } catch (e) {
                    reject(e);
                }
            };
            img.onerror = reject;
            img.src = reader.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
